import React from "react";
import { Field } from "formik";
import { Flex } from "../../../Flex";
import { Span } from "../../../Span";
import { FormikRadioButton } from "../../../FormikRadioButton";
import { CloseableNotificationBanner } from "../../../CloseableNotificationBanner";
import { Box } from "../../../Box";

interface Props {
  id: string;
  hasTenants?: string;
}

export const DisconnectionDetailsIssues: React.FC<Props> = ({
  id,
  hasTenants,
}) => {
  return (
    <Flex
      id={id}
      flexDirection="column"
      flexGrow={0.3}
      flexBasis={0}
      minWidth={["100%", "100%", "100%", 0]}
      mb={4}
    >
      <Flex pl={2} pr={2}>
        <Span
          display="inline-block"
          fontSize={2}
          lineHeight={2}
          fontWeight="medium"
        >
          Are there any tenants in the building?
        </Span>
      </Flex>
      <Flex mt={3} flexDirection={"row"} flexWrap={"nowrap"}>
        <Flex>
          <Box mr={2}>
            <Field
              magnitude="small"
              label="Yes"
              id="yes tenants"
              name={"disconnectionDetails.hasTenants"}
              value="yes"
              currentValue={hasTenants}
              component={FormikRadioButton}
              useTimeout
            />
          </Box>
          <Field
            magnitude="small"
            label="No"
            id="no tenants"
            name={"disconnectionDetails.hasTenants"}
            value="no"
            currentValue={hasTenants}
            component={FormikRadioButton}
            useTimeout
          />
        </Flex>
      </Flex>
      {hasTenants === "yes" && (
        <Flex flexDirection="column" mt={4}>
          <CloseableNotificationBanner
            title="Please note"
            message={() =>
              "It's your responsibility to advise the tenants of the permanent disconnection"
            }
            icon="info"
            variant="information"
            visible={true}
          />{" "}
        </Flex>
      )}
    </Flex>
  );
};
